<template>
    <div class="main-template-root">
        <Header/>
        <div class="page-wrapper">
            <Sidebar/>
            <div class="page-content">
                <div class="container-fluid">
                    <transition name="fade">
                        <router-view/>
                    </transition>
                </div>
                <footer class="footer text-center">
                    &copy; PT. Bank Pembangunan Daerah Bali
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from "@/components/layouts/Header";
    import Sidebar from "@/components/layouts/Sidebar";
    export default {
        components: {
            Header,
            Sidebar
        },
        mounted () {
            require('@/assets/js/app.js')
            $(".metismenu").metisMenu();
        },
        watch:{
            $route (to, from){
                // console.log(to);
            }
        }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition-property: opacity;
        transition-duration: .005s;
    }

    .fade-enter-active {
        transition-delay: .35s;
    }

    .fade-enter, .fade-leave-active {
        opacity: 0
    }
</style>